<template>
  <modal-v2
    class="verification-stamp-modal"
    ref="VerificationStampModal"
    :close-on-click-outside="true"
  >
    <template #header="">
      <svg class="verification-stamp-modal__icon">
        <use :xlink:href="getModalConfig('ICON')"></use>
      </svg>

      <h2 class="verification-stamp-modal__title">
        {{getModalConfig('TITLE')}}
      </h2>

    </template>

    <template #body="">
      <p class="verification-stamp-modal__text">
        {{getModalConfig('BODY')}}
      </p>
    </template>

    <template #footer="">
      <button
        class="mui-button mui-button--primary"
        @click.prevent="[redirectToLink(), close()]"
      >
        {{getModalConfig('BUTTON')}}
      </button>
    </template>
  </modal-v2>
</template>

<script>
import verificationStamp from 'commons/js/mixins/verificationStamp';
import ModalV2 from "commons/js/components/atoms/ModalV2.vue";

export default {
  components: {
    ModalV2
  },

  mixins: [verificationStamp],

  props: {
    userVerificationStatus: {
      type: String,
      required: true
    }
  },

  methods: {

    /**
     * Opens the modal
     */
    open() {
      this.$refs.VerificationStampModal.open();
    },

    /**
     * Closes the modal
     */
    close() {
      this.$refs.VerificationStampModal.close();
    }
	},

  watch: {

    /**
     * Updates the user status when the prop changes
     * @param {string} value
     */
    userVerificationStatus(value) {
      this.userStatus = value;
    }
  }
}
</script>

<style lang="stylus" scoped>
.verification-stamp-modal
  &__icon
    width 40px
    height 40px
    margin-bottom 24px

  &__title
    font-weight bold
    font-size 20px
    line-height 24px

  &__text
    margin 0

  .modal-v2__body
    margin-top 8px
    margin-bottom 0

  .modal-v2__footer
    padding-top 16px

</style>
